import { getPropsForClickTracking } from "../../utils/tracking";
import type { MapItemCard } from "../../@types/mapviewxs";
import type { WatchListEntries } from "../map/types";
export interface Input {
  itemCard?: MapItemCard;
  isPrev?: boolean;
  handleWatchListItemToggle?: (listingid: string) => void;
  watchListItems?: WatchListEntries;
}
$ const { itemCard, isPrev, watchListItems, handleWatchListItemToggle } = input || {};
$ const { card, hotnessSignal, trackingList, signalling, sponsored, productRating, sellerName, sellerRating, listingFormat } = itemCard || {};

<if(card)>
  <div data-testid="map-item" class=["map-item", isPrev && "prev"]>
    <div class="map-item-image-container">
      <item-watchlist model=card handleWatchListItemToggle=handleWatchListItemToggle watchListItems=watchListItems/>
      <img class="map-item-image" src=(card.image?.URL) alt=(card.title?.textSpans?.[0].text)>
    </div>
    <div class="map-item-content-container">
      <if(hotnessSignal)>
        <hotness-signal model=hotnessSignal/>
      </if>
      <a
        rel="noreferrer"
        target="_blank"
        class="map-item-title"
        title=(card.title?.textSpans?.[0].text)
        href=(card.action?.URL)
        ...getPropsForClickTracking(trackingList)
      >
        <span class="action-expand"/>
        <fe-textual-display model=card.title/>
      </a>

      <div class="map-item-details">
        <fe-textual-display model=signalling/>
      </div>
      <item-seller-info productRating=productRating sellerName=sellerName sellerRating=sellerRating/>
      <div class="map-item-price">
        <item-price-display displayPrice=card.displayPrice listingFormat=listingFormat/>
      </div>
      <if(card.distance)>
        <div class="map-item-distance">
          <fe-textual-display model=card.distance/>
        </div>
      </if>
      <if(sponsored)>
        <div class="map-item-sponsored-label">
          <fe-textual-display model=sponsored/>
        </div>
      </if>
    </div>
  </div>
</if>
